import React from "react";
import './microsoft.css'

export type MicrosoftLoginButtonTheme =
  | "dark_short"
  | "light_short"
  | "dark"
  | "light";

interface MicrosoftLoginButtonProps {
  onClick?: any;
}

export const MicrosoftLoginButton: React.FunctionComponent<MicrosoftLoginButtonProps> = ({
  onClick,
}) => {
    return (
      <div className="flex justify-center">
        <button 
          onClick={onClick.bind(this)} 
          id="signInWithMicrosoft" 
          className="msSignInButton flex items-center justify-center gap-3 bg-white hover:bg-gray-50 border border-gray-300 rounded-lg px-4 py-3 text-sm font-medium text-gray-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
          style={{ minWidth: '240px' }}
        >
          <span className="msIcon"></span>
          Sign in with Microsoft
        </button>
      </div>
    );
};